import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getCurrentBetCashedOutPrice } from '../../../openBets/selectors';

const Congratulations = ({ value }) => (
  <div className="congratulations">
    <h2 className="congratulations__header">Congratulations!</h2>
    <div className="congratulations__info">
      You cashed out this bet for £{value}! Please collect your winnings in shop
    </div>
  </div>
);

Congratulations.propTypes = {
  value: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  value: getCurrentBetCashedOutPrice(state)
});

export default connect(mapStateToProps)(Congratulations);
